export default function Marquee({ items, fast = false, small = false }) {
  return (
    <div
      data-testid={small ? "micro-marquee" : "editorial-marquee"}
      className={`overflow-hidden border-y border-border bg-background select-none ${small ? "py-3" : "py-8"}`}
    >
      <div className={`flex w-max ${fast ? "animate-marquee-fast" : "animate-marquee"}`}>
        {[0, 1].map((copy) => (
          <div key={copy} className="flex items-center shrink-0">
            {items.map((t, i) => (
              <span key={`${copy}-${i}`} className="flex items-center shrink-0">
                <span
                  className={
                    small
                      ? `text-[10px] uppercase tracking-[0.35em] px-6 whitespace-nowrap ${i % 2 ? "text-primary" : "text-muted-foreground"}`
                      : `font-display text-4xl md:text-6xl font-light px-8 whitespace-nowrap ${i % 2 ? "outline-text" : "text-foreground/90"}`
                  }
                >
                  {t}
                </span>
                <span className={`rotate-45 bg-primary/70 shrink-0 ${small ? "w-1.5 h-1.5" : "w-2 h-2"}`} />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
